import React from "react";
import "../styles/Preloader.css";

const Preloader = () => {
  return (
    <div className="preloaderContainer">
      <div className="preloader"></div>
    </div>
  );
};

export default Preloader;
